import baseAPI from '@/api/base';
import {
  EditEmployeeOffboarding,
  GetEmployeeOffboarding,
  RegisterEmployeeOffboarding,
} from '@/dtos/employee_offboarding.dto';
import {
  DELETE_EMPLOYEE_OFFBOARDING_URL,
  EDIT_EMPLOYEE_OFFBOARDING_URL,
  GET_EMPLOYEE_OFFBOARDING_URL,
  REGISTER_EMPLOYEE_OFFBOARDING_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class EmployeeOffboarding {
  static getEmployeeOffboardings = async (
    params: GetEmployeeOffboarding
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_EMPLOYEE_OFFBOARDING_URL, {
      params,
    });
    return response;
  };

  static registerEmployeeOffboarding = async (
    payload: RegisterEmployeeOffboarding
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_EMPLOYEE_OFFBOARDING_URL, {
      ...payload,
    });
    return response;
  };

  static editEmployeeOffboarding = async (
    payload: EditEmployeeOffboarding
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_EMPLOYEE_OFFBOARDING_URL, {
      ...payload,
    });
    return response;
  };

  static deleteEmployeeOffboarding = async (id: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_EMPLOYEE_OFFBOARDING_URL}/${id}`
    );
    return response;
  };
}

export default EmployeeOffboarding;
